import { InterInstance } from './config';

export const getPromoBanner = async (id: string) => {
  try {
    const  data  = await InterInstance.get(`promo-banner?companyId=${id}`, {
      //headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (e) {
    return e;
  }
};
